import React from "react";
import { Chip, Tooltip } from "@mui/material";
import WorkspaceIcon from "@mui/icons-material/EmojiEvents";
import MilitaryTechIcon from "@mui/icons-material/MilitaryTech";
import VerifiedIcon from "@mui/icons-material/Verified";

// Niveles de certificación por examen de habilidad. Distintos de las insignias
// de suscripción (Plata/Oro/Platino) para no confundir ambos sistemas.
export const CERTIFICATION_LEVELS = [
  { min: 90, label: "Certificado Experto", color: "#d4a017", Icon: WorkspaceIcon },
  { min: 75, label: "Certificado Avanzado", color: "#4a90d9", Icon: MilitaryTechIcon },
  { min: 60, label: "Certificado", color: "#4caf50", Icon: VerifiedIcon },
];

export const getCertificationLevel = (score) => {
  return CERTIFICATION_LEVELS.find((level) => score >= level.min) || null;
};

export const UNLOCK_CERTIFICATION_PRICE = 3;

export const CertificationChip = ({ skill, score, size = "small" }) => {
  const level = getCertificationLevel(score);
  if (!level) return null;
  const { label, color, Icon } = level;
  return (
    <Tooltip title={`${skill}: ${score}% — ${label}`}>
      <Chip
        size={size}
        icon={<Icon sx={{ color: `${color} !important` }} />}
        label={`${skill} · ${label}`}
        variant="outlined"
        sx={{ borderColor: color, color }}
      />
    </Tooltip>
  );
};
